import { useEffect, useState, useCallback } from "react";
import { PageHeader, Panel } from "@/components/PageHeader";
import { TesseraCard, TesseraImage, TesseraQR } from "@/components/TesseraCard";
import { WelcomeHero } from "@/components/WelcomeHero";
import { useAuth } from "@/context/AuthContext";
import { IscrizioneForm } from "@/components/IscrizioneForm";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, euro, fmtDateTime, pagamentoLabel } from "@/lib/api";

const Storico = ({ items }) => (
  <Panel className="mt-8">
    <h2 className="font-heading text-2xl uppercase mb-4">Storico iscrizioni</h2>
    <Table data-testid="storico-table">
      <TableHeader>
        <TableRow><TableHead>Anno</TableHead><TableHead>Categoria</TableHead><TableHead>Barca</TableHead><TableHead>Importo</TableHead><TableHead>Pagamento</TableHead><TableHead>Stato</TableHead><TableHead>Data</TableHead></TableRow>
      </TableHeader>
      <TableBody>
        {items.map((m) => (
          <TableRow key={m.id}>
            <TableCell className="font-mono-x">{m.anno}</TableCell>
            <TableCell>{m.categoria_socio}</TableCell>
            <TableCell>{m.categoria_barca || "—"}</TableCell>
            <TableCell>{euro(m.importo)}</TableCell>
            <TableCell>{pagamentoLabel(m.metodo_pagamento)}</TableCell>
            <TableCell>{m.pagamento_confermato ? "Confermato" : "In verifica"}</TableCell>
            <TableCell>{fmtDateTime(m.created_at)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Panel>
);

export default function Tessera() {
  const { user } = useAuth();
  const [ms, setMs] = useState(null);
  const [quote, setQuote] = useState([]);
  const [boats, setBoats] = useState([]);

  const load = useCallback(async () => {
    const { data } = await api.get("/memberships/me");
    setMs(data);
    const [q, b] = await Promise.all([api.get("/quote", { params: { anno: data.anno } }), api.get("/boats")]);
    setQuote(q.data);
    setBoats([...b.data.mine, ...b.data.crew]);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (!ms) return null;
  const rinnovo = ms.storico.length > 0;
  return (
    <div>
      <PageHeader kicker={`Anno associativo ${ms.anno}`} title="Tessera" />
      {ms.current ? (
        <div className="grid grid-cols-1 lg:grid-cols-[auto_1fr] gap-8 items-start">
          {ms.current.pagamento_confermato ? <TesseraImage m={ms.current} /> : <TesseraCard m={ms.current} />}
          <Panel>
            <h2 className="font-heading text-2xl uppercase mb-2">Sei iscritto per il {ms.anno}</h2>
            <p className="text-muted-foreground" data-testid="tessera-already-member">
              La tua iscrizione è valida dal 1 gennaio al 31 dicembre {ms.anno}.
              {!ms.current.pagamento_confermato && " Il pagamento è in attesa di conferma da parte della segreteria."}
            </p>
            <div className="mt-6 pt-6 border-t"><TesseraQR m={ms.current} /></div>
          </Panel>
        </div>
      ) : (
        <>
        <WelcomeHero user={user} ms={ms} testid="tessera" joinTitle onJoin={() => document.getElementById("iscrizione")?.scrollIntoView({ behavior: "smooth", block: "start" })} />
        <Panel className="fade-up scroll-mt-24" id="iscrizione">
          <h2 className="font-heading text-3xl uppercase mb-1">{rinnovo ? `Rinnovo iscrizione ${ms.anno}` : `Associati per il ${ms.anno}`}</h2>
          <p className="text-muted-foreground mb-6">
            {rinnovo ? `Il tuo numero di tessera ${ms.tessera_numero} rimarrà invariato.` : "Al termine riceverai il tuo numero di tessera."}
          </p>
          <IscrizioneForm anno={ms.anno} quote={quote} boats={boats} rinnovo={rinnovo} prev={ms.storico[0]} onDone={load} />
        </Panel>
        </>
      )}
      {ms.storico.length > 0 && <Storico items={ms.storico} />}
    </div>
  );
}
